<template>
  <div>
      <BRow class="mb-3">
      <BCol cols="12">
          <div v-if="noMetadata">
                <p>Geen gegevens beschikbaar.</p>
          </div>
          <BTableSimple small v-else>
              <colgroup>
                  <col>
                  <col>
              </colgroup>
              <BTbody>
                  <b-tr v-for="(metadata, index) in salesOrderMetadata" :key="index">
                      <b-th style="width: 50%">{{ metadata.name }}</b-th>
                      <b-td>{{ metadata.value }}</b-td>
                  </b-tr>
              </BTbody>
          </BTableSimple>
      </BCol>
    </BRow>
  </div>
</template>

<script>

export default {
  name: "ShowSalesOrderMetadata",
  props: {
    salesOrder: {
      type: Object,
      required: true,
      default: {},
    },
  },
  computed: {
    salesOrderMetadata() {
        let data = []
        for (const [key, value] of Object.entries(this.salesOrder.metadata)) {
            if (this.$store.state.config['sales-order-metadata-fields'][key]) {
                data.push({
                    name: this.prettify(key),
                    value: value
                })
            }
        }
        return data
    },

    noMetadata() {
        return this.salesOrderMetadata.length === 0;
    },
  },
  methods: {
      prettify(s) {
          s = s.replace(/_/g, ' ')
          return s.replace(/(\w)(\w*)/g,
              function(g0,g1,g2){return g1.toUpperCase() + g2.toLowerCase();});
      }
  }
};
</script>